import { companyIdSchema } from "./company.js";
const ServiceAccessSessionEndedReason = {
  /** An employee ended it: its own, or anyone's from HQ. */
  ENDED: "ended",
  /** The HQ passkey that started it was removed. */
  PASSKEY_REMOVED: "passkey_removed",
  /** A refresh token was presented again after it had been rotated. */
  REFRESH_REUSE: "refresh_reuse"
};
const SERVICE_ACCESS_OWN_COMPANY_ERROR_CODE = "own_company";
const ServiceAccessTokenKind = {
  ACCESS: "access",
  REFRESH: "refresh"
};
function stringifyServiceAccessOrigin(serviceAccessDomain, companyId) {
  const url = new URL("http://localhost");
  url.host = serviceAccessDomain;
  const isLocalhost = url.hostname === "localhost" || url.hostname.endsWith(".localhost");
  if (!isLocalhost) {
    url.protocol = "https:";
  }
  url.hostname = `${companyId}.${url.hostname}`;
  return url.origin;
}
const LOCALHOST_SERVICE_ACCESS_HOSTNAME = "customers.localhost";
function parseServiceAccessOrigin(serviceAccessDomain, origin) {
  if (!URL.canParse(origin)) {
    return null;
  }
  const url = new URL(origin);
  const [label] = url.hostname.split(".");
  const result = companyIdSchema.safeParse(label);
  if (!result.success) {
    return null;
  }
  const domains = [serviceAccessDomain];
  if (url.port !== "") {
    const localhostDomain = new URL("http://localhost");
    localhostDomain.hostname = LOCALHOST_SERVICE_ACCESS_HOSTNAME;
    localhostDomain.port = url.port;
    domains.push(localhostDomain.host);
  }
  const isCompanyOrigin = domains.some(
    (domain) => stringifyServiceAccessOrigin(domain, result.data) === origin
  );
  return isCompanyOrigin ? result.data : null;
}
function checkIsServiceAccessCallbackUrl(serviceAccessDomain, companyId, url) {
  if (!URL.canParse(url)) {
    return false;
  }
  const { origin } = new URL(url);
  return parseServiceAccessOrigin(serviceAccessDomain, origin) === companyId && new URL("/service-access/callback", origin).toString() === url;
}
export {
  SERVICE_ACCESS_OWN_COMPANY_ERROR_CODE,
  ServiceAccessSessionEndedReason,
  ServiceAccessTokenKind,
  checkIsServiceAccessCallbackUrl,
  parseServiceAccessOrigin,
  stringifyServiceAccessOrigin
};
//# sourceMappingURL=serviceAccess.js.map
